export class MapDropdowns {
  private mapDropdowns: NodeListOf<Element>;
  constructor() {
    this.mapDropdowns = document.querySelectorAll('.js-vrsMap__poiPin--desktop');
    if (this.mapDropdowns.length) {
      this.handleMapDropdowns();
    }
  }

  handleMapDropdowns() {
    this.mapDropdowns.forEach(
      item => {
        item.addEventListener('click', (event: Event) => {
          const itemParent = item.closest('.vrsMap__poiWrapper');

          // Remove all Active-States
          if (!item.classList.contains('vrsMap__poi--active')) {
            const parentFrame = item.closest('.frame');
            const activePins = parentFrame!.querySelectorAll('.vrsMap__poi--active');

            activePins.forEach(activePin => {
              const activePinParent = activePin.closest('.vrsMap__poiWrapper');
              activePinParent!.classList.remove('vrsMap__poiWrapper--active');
              activePin.classList.remove('vrsMap__poi--active');
            });
          }

          // Handle Click-Event
          item.classList.toggle('vrsMap__poi--active');
          itemParent!.classList.toggle('vrsMap__poiWrapper--active');
        });
      });

    // Handle Outside-Click
    document.addEventListener('click', (event: Event) => {
      const isClickedInside = (event.target as HTMLElement).closest('.vrsMap__poiWrapper');
      if (!isClickedInside) {
        this.mapDropdowns.forEach(
          item => {
            const itemParent = item.closest('.vrsMap__poiWrapper');

            item.classList.remove('vrsMap__poi--active');
            itemParent!.classList.remove('vrsMap__poiWrapper--active');
          });
      }
    });
  }
}
